import React from "react";
import { withStyles } from "@material-ui/core";
import { get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import SchedulerCalendarWeeklyDay from "./SchedulerCalendarWeeklyDay";

import colors from "../../../assets/style/colors";
const styles = {
  container: {
    height: "100%",
    maxWidth: "calc(100vw - 203px)",
    overflow: "auto",
    borderLeft: `1px solid ${colors.veryLighPink}`,
    "@media print": {
      maxWidth: "unset",
    },
  },
};

const SchedulerCalendarWeekly = (props) => {
  const { classes, data, timeSlots, refresh, showCustomTimeSlots, end } = props;

  return (
    <Grid
      container
      data-test="scheduler-calendar-weekly-component"
      className={classes.container}
      wrap="nowrap"
    >
      {map(data, (d, i) => (
        <SchedulerCalendarWeeklyDay
          key={i}
          data-test="scheduler-calendar-day-item"
          date={get(d, ["start"])}
          occurrencesPerDay={data}
          occurrences={get(d, ["occurrences"])}
          timeSlots={timeSlots}
          refresh={refresh}
          showCustomTimeSlots={showCustomTimeSlots}
          end={end}
        />
      ))}
    </Grid>
  );
};

export default withStyles(styles)(SchedulerCalendarWeekly);
